export const GETREGISTEREDDEVICEDETAILS = "GETREGISTEREDDEVICEDETAILS";
export const GETREGISTEREDDEVICEDETAILS_ERROR = "GETREGISTEREDDEVICEDETAILS_ERROR";
export const GETREGISTEREDDEVICEDETAILS_HIDE_ERROR = "GETREGISTEREDDEVICEDETAILS_HIDE_ERROR";
export const GETREGISTEREDDEVICEDETAILS_START_LOADER = "GETREGISTEREDDEVICEDETAILS_START_LOADER";
export const GETREGISTEREDDEVICEDETAILS_STOP_LOADER = "GETREGISTEREDDEVICEDETAILS_STOP_LOADER";
